export const GLOBAL_CONTEXT = '__GLOBAL__';
export const ACTIVATOR_KEY_REGEX =
  /^(?:[A-Z0-9\?]|ARROW(?:UP|DOWN|LEFT|RIGHT)|ESCAPE|ENTER|TAB|DELETE|BACKSPACE|SPACE)$/;
export const DOUBLE_FIRE_DELAY_IN_MS = 100;
